module.exports = __webpack_public_path__ + "static/media/i-access.f869b014.svg";